import { Component, AfterViewInit, OnInit } from '@angular/core';
import { ROUTES } from './menu-items';
import { RouteInfo } from './sidebar.metadata';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {SidebarServiceService} from './sidebar-service.service';
import {HeaderService} from '../../layouts/header.service';
declare var $: any;

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html'
})
export class SidebarComponent implements OnInit {
  showMenu = '';
  public sidebarnavItems: any[];
  // this is for the open close

  console = console

  width

  addExpandClass(element: any) {
    if (element === this.showMenu) {
      this.showMenu = '0';
    } else {
      this.showMenu = element;
    }
  }

  headerService: HeaderService

  constructor(
    private modalService: NgbModal,
    private router: Router,
    private route: ActivatedRoute,
    private changeRouter: SidebarServiceService,
    headerService: HeaderService,
    private sidebarServiceService: SidebarServiceService
  ) {
    sidebarServiceService.width.subscribe(num => {
      this.width = num
    })

    this.headerService = headerService
    changeRouter.locationChanged.subscribe(location => {
      for (let route of ROUTES) {
        if (route.path == location) {
          this.showMenu = route.title
        }
      }
      if (location == '/admin/dashboard')
        this.showMenu = 'Dashboard'
    })
  }

  // End open close
  ngOnInit() {
    this.sidebarnavItems = ROUTES.filter(sidebarnavItem => sidebarnavItem);
    if (this.router.url == '/admin/dashboard')
      this.showMenu = 'Dashboard'
  }
}
